import React from "react";
import "./Casino.sass";

export default function Casino() {
  return (
    <div className="casino not-mobile">
      <div className="casino-top">
        <div className="casino-coin">
          <img src="/images/coin.png" alt="coin" />
        </div>
        <div className="casino-logo">
          <img src="/images/casino.png" alt="casino" />
        </div>
        <div className="casino-coin">
          <img src="/images/coin.png" alt="coin" />
        </div>
      </div>
      <h3>COMING SOON</h3>
    </div>
  );
}
